<script>
	import { Calendar } from "@xbs/svelte-wx";
	import { uid } from "@xbs/lib-state";

	const prevent = event => event.preventDefault();

	export let item;

	$: store = item.store;
	$: value = item.value;

	const change = () => {
		const { menuState } = store.getState();
		const selected = store.getSelection().map(id => ({
			...store.getTask(id),
			due_date: value || null,
		}));

		let $meta;
		if (selected.length > 1) {
			$meta = { batch: uid() };
		}

		store.eachSelected((id, index) => {
			const task = store.getTask(id);
			store.in.exec("update-task", {
				id,
				task: {
					...task,
					due_date: value || null,
				},
				skipProvider: !!index,
				batch: !index ? selected.slice(1) : [],
				$meta,
			});
		});

		store.in.exec("close-menu", { ...menuState });
	};

</script>

<div class="wx-todo_date-item" on:click={prevent}>
	<Calendar bind:value on:change={change} />
</div>

<style>
	.wx-todo_date-item {
		min-width: 200px;
		max-width: 100%;
		width: 100%;
	}

</style>
